const mapApplePayContactAddress = (paymentContact) => ({
  firstName: paymentContact.givenName || "",
  lastName: paymentContact.familyName || "",
  streetName: paymentContact.addressLines?.[0] || "",
  streetNumber: paymentContact.addressLines?.[1] || "",
  postalCode: paymentContact?.postalCode || "",
  city: paymentContact?.locality || "",
  countryCode: paymentContact.countryCode || "",
  ...paymentContact.phoneNumber ? { phone: paymentContact.phoneNumber } : {},
  // We only have a region field. We don't make distinctions between main and sub.
  ...paymentContact.emailAddress ? { email: paymentContact.emailAddress } : {},
  ...paymentContact.administrativeArea ? { region: paymentContact.administrativeArea } : {},
  ...paymentContact.subAdministrativeArea ? { region: paymentContact.subAdministrativeArea } : {}
});
export {
  mapApplePayContactAddress
};
//# sourceMappingURL=apple-pay-contact-address.js.map
